import React, { useContext, useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import Cookies from "js-cookie";
import avatar from "../../assets/images/avatar.svg";
import { ModalComp, Profile } from "../../shared";
import { invitationListApi } from "../../api";
import { setInvitationList } from "../../redux";
import { withRouter } from "react-router-dom";
import { ProfileSection } from "../../context/ProfileContext";
import { useTranslation } from "react-i18next";

const UserInfoComp = (props) => {
  const { t } = useTranslation();
  const [openModal, setOpenModal] = useState(false);
  const token = Cookies.get("token");
  const dispatch = useDispatch();
  const [showAlert, setShowAlert] = useState({
    show: false,
    message: "",
    type: "",
  });
  const { ProfileShowHideFunc } = useContext(ProfileSection);
  const toggle = () => {
    setOpenModal(!openModal);
    setUpd(!upd);
    ProfileShowHideFunc("firstPage");
    invitationListApi(token)
      .then((res) => {
        // console.log(res);
        dispatch(setInvitationList(res.data.data));
      })
      .catch((err) => {
        if (err.response.status === 403) {
          Cookies.remove("token");
          props.history.push("/login");
          setShowAlert((prevState) => ({
            ...prevState,
            show: true,
            message: t("خطایی رخ داده است . لطفا مجددا امتحان کنید."),
            type: "Error",
          }));
          setTimeout(() => {
            setShowAlert((prevState) => ({
              ...prevState,
              show: false,
            }));
          }, 2000);
        }
      });
  };
  const userInfo = useSelector((state) => state.userProfileInfo);
  const [upd, setUpd] = useState(false);
  return (
    <>
      <ModalComp
        modal={openModal}
        toggle={toggle}
        component={<Profile props={upd} />}
      />
      <div
        className="urerInfo position-relative d-flex align-items-center justify-content-between p-2 text-right cursor"
        onClick={toggle}
      >
        <div className="userImg">
          <img
            src={`https://assessn.mmaviot.com${userInfo.image}`}
            alt="avatar"
            className="w-100 h-100 rounded-circle"
          />
          <span className="activeUser d-block position-absolute bg-priimary"></span>
        </div>
        <div>
          <p className="m-0 ">{userInfo.name}</p>
          <small>{userInfo.email}</small>
        </div>
        <i className="arrow rounded-circle text-center icon-down-open-big"></i>
      </div>
    </>
  );
};

const UserInfo = withRouter(UserInfoComp);

export { UserInfo };
